"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.5.0'] && _();
}
catch (e) { }
